// extracted by mini-css-extract-plugin
export default {"ErrorPage":"Error_ErrorPage__rUAVZ","errorname":"Error_errorname__J3e+3"};